export const validateObject = ( data = {}, equalZero = false  ) => {
  try {
    if ( !equalZero ) return Object.keys( data ).length > 0 ? true : false;
    else return Object.keys( data ).length  ===  0 ? true : false;
  } catch (error) {
    return false
  }
}


export const cleanObject = (obj) => {
  const cleanedObj = {};

  try {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        cleanedObj[key] = obj[key] !== null && obj[key] !== undefined ? obj[key] : "";
      }
    }
    return cleanedObj;
  } catch (error) {
    console.log(error);
    return cleanedObj; 
  }
};

/**
 * Verifica si un valor es null o undefined.
 * @param {*} value - Valor a evaluar.
 * @returns {boolean}
 */
export const isNullOrUndefined = (value) => value === null || value === undefined;
